package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.CheckboxInput
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val checkbox = Bem("admin-checkbox")

/** A yes/no option written as a sentence; the whole label is the click target. [note] names the value it changes. */
@Composable
fun AdminCheckbox(
    label: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    note: String? = null,
) {
    Label(attrs = { classes(checkbox.block) }) {
        CheckboxInput(checked) {
            classes(checkbox.element("input").className)
            onInput { onCheckedChange(it.value) }
        }
        Text(" $label")
        note?.let {
            Text(" ")
            Span({ classes(checkbox.element("note").className) }) { Text(it) }
        }
    }
}
